export const REQUEST = 'REQUEST'
export const SUCCESS = 'SUCCESS'
export const FAILURE = 'FAILURE'

export const ENTITY_REQUESTING = 'Requesting'
export const ENTITY_FAILURE = 'Failure'

function action(type, payload = {}) {
  return { type, ...payload }
}

function createRequestTypes(base) {
  return [REQUEST, SUCCESS, FAILURE].reduce((acc, type) => {
    acc[type] = `${base}_${type}`
    return acc
  }, {})
}

export const ECARDS = createRequestTypes('ECARDS')
export const REDEEMED_FREE_CARDS = createRequestTypes('REDEEMED_FREE_CARDS')
export const CARDREQUESTOPTIONS = createRequestTypes('CARDREQUESTOPTIONS')
export const SHAREECARDS = createRequestTypes('SHAREECARDS')
export const WECHATUSER = createRequestTypes('WECHATUSER')
export const FORGOT_PASSWORD = createRequestTypes('FORGOT_PASSWORD')
export const LOAD_ECARDS_PAGE = 'LOAD_ECARDS_PAGE'
export const RESET_ERROR_MESSAGE = 'RESET_ERROR_MESSAGE'
export const PAGE_LOADING = 'PAGE_LOADING'
export const PAGE_LOADED = 'PAGE_LOADED'
export const ERRORDIALOG = 'ERRORDIALOG'
export const SKIP_ROUTER = 'SKIP_ROUTER'

export const REQUEST_MOBILE_CODE = 'REQUEST_MOBILE_CODE'
export const VERIFY_MOBILE_CODE = 'VERIFY_MOBILE_CODE'
export const REQUEST_EMAIL_CODE = 'REQUEST_EMAIL_CODE'
export const VERIFY_EMAIL_CODE = 'VERIFY_EMAIL_CODE'
export const PROFILE = createRequestTypes('PROFILE')
export const POST_PASSWORD = 'POST_PASSWORD'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const ADD_TO_CART = 'ADD_TO_CART'
export const DELECT_CART_ITEM = 'DELECT_CART_ITEM'
export const CHECKED_ALL = 'CHECKED_ALL'
export const ADD_TO_CHECKED = 'ADD_TO_CHECKED'
export const REMOVE_CHECKED = 'REMOVE_CHECKED'
export const REMOVE_ALL = 'REMOVE_ALL'
export const REPLACE_CARD = 'REPLACE_CARD'
export const SHOPPINGCART = createRequestTypes('SHOPPINGCART')
export const CREDENTIAL_REQUEST = 'CREDENTIAL_REQUEST'
export const SUBMIT_SUCCESS = 'SUBMIT_SUCCESS'
export const HAS_PIG_CARD = createRequestTypes('HAS_PIG_CARD')
export const SUBMIT_ECARD_IMG_BINDING = createRequestTypes('SUBMIT_ECARD_IMG_BINDING')
export const REQUEST_HAS_PIG_YEAR_CARD = 'REQUEST_HAS_PIG_YEAR_CARD'
export const REGISTRATION_RESULT = 'REGISTRATION_RESULT'
export const TO_PIG_CARD = 'TO_PIG_CARD'
export const REFRESH_ECARDS = 'REFRESH_ECARDS'
export const NOTICE_DISPLAY = 'NOTICE_DISPLAY'
export const NOTICE_HIDE = 'NOTICE_HIDE'
export const SHOW_TOAST = 'SHOW_TOAST'
export const CLEAR_TOAST = 'CLEAR_TOAST'
export const REQUEST_YOUZAN_STATUS = 'REQUEST_YOUZAN_STATUS'
export const REQUEST_YOUZAN_MOBILE_CODE = 'REQUEST_YOUZAN_MOBILE_CODE'
export const REQUEST_PROFILES = 'REQUEST_PROFILES'
export const VERIFY_MOBILE = createRequestTypes('VERIFY_MOBILE')
export const REQUEST_SHOPPING_CART = 'REQUEST_SHOPPING_CART'
export const SUBMIT_SHOPPING_CART = createRequestTypes('SUBMIT_SHOPPING_CART')
export const REQUEST_CARD_OPTIONS_PAGE = 'REQUEST_CARD_OPTIONS_PAGE'
export const SUBMIT_MEMBER_RENEW = 'SUBMIT_MEMBER_RENEW'
export const SUBMIT_STORE_RENEW = 'SUBMIT_STORE_RENEW'
export const REQUEST_MEMBER_RENEW = 'REQUEST_MEMBER_RENEW'
export const MEMBER_RENEW = createRequestTypes('MEMBER_RENEW')
export const STORE_RENEW = createRequestTypes('STORE_RENEW')
export const MEMBER_RENEW_FUIOU_ORDER = createRequestTypes('MEMBER_RENEW_FUIOU_ORDER')
export const STORE_RENEW_FUIOU_ORDER = createRequestTypes('STORE_RENEW_FUIOU_ORDER')
export const HIDE_FUIOU_RENEW_QR = 'HIDE_FUIOU_RENEW_QR'
export const CLEAR_CARDREQUEST_INFO = 'CLEAR_CARDREQUEST_INFO'
export const ADD_ECARD_DATA = 'ADD_ECARD_DATA'
export const REQUEST_WECHAT_USER = 'REQUEST_WECHAT_USER'
export const RESET_APP = 'RESET_APP'
export const SAVE_WECHAT_JS_CONFIG = 'SAVE_WECHAT_JS_CONFIG'
export const REQUEST_MEMBER_LIBRARY = 'REQUEST_MEMBER_LIBRARY'
export const REQUEST_QUALIFICATION = 'REQUEST_QUALIFICATION'
export const SKIP_PATH = 'SKIP_PATH'
export const INSTRUCTOR_APPROVED = 'INSTRUCTOR_APPROVED'
export const SAVE_PROFILE = createRequestTypes('SAVE_PROFILE')
export const CD_SUBMIT_SI = 'CD_SUBMIT_SI'
export const CD_SUBMIT_APP = createRequestTypes('CD_SUBMIT_APP')
export const REFRESH_TOKEN = createRequestTypes('REFRESH_TOKEN')
export const POST_PROFILE = 'POST_PROFILE'
export const CHNAGE_ECARDS_ACTIVE_TRUE = 'CHNAGE_ECARDS_ACTIVE_TRUE'
export const CHNAGE_ECARDS_ACTIVE_FALSE = 'CHNAGE_ECARDS_ACTIVE_FALSE'

export const requestMobileCode = (data) => action(REQUEST_MOBILE_CODE, data)

export const verifyMobileCode = (data) => action(VERIFY_MOBILE_CODE, { data })

export const requestEmailCode = (data) => action(REQUEST_EMAIL_CODE, data)

export const verifyEmailCode = (data) => action(VERIFY_EMAIL_CODE, { data })

export const postPassword = (data) => action(POST_PASSWORD, { data })

export const postProfile = (data) => action(POST_PROFILE, { data })

export const addToCart = (data) => action(ADD_TO_CART, { data })

export const delectCartItem = (data) => action(DELECT_CART_ITEM, { data })

export const checkedAll = (data) => action(CHECKED_ALL, { data })

export const removeAll = () => action(REMOVE_ALL)

export const addToChecked = (data) => action(ADD_TO_CHECKED, { data })

export const removeChecked = (data) => action(REMOVE_CHECKED, { data })

export const replaceCard = (data) => action(REPLACE_CARD, { data })

export const credentialRequest = (data) => action(CREDENTIAL_REQUEST, { data })

export const submitSuccess = () => action(SUBMIT_SUCCESS)

export const requestHasPigYearCard = () => action(REQUEST_HAS_PIG_YEAR_CARD)

export const registrationResult = (data) => action(REGISTRATION_RESULT, { data })

export const toPigCard = (data) => action(TO_PIG_CARD, { data })

export const refreshEcards = (data) => action(REFRESH_ECARDS, { data })

export const requestYouzanStatus = () => action(REQUEST_YOUZAN_STATUS)

export const requestYouzanMobileCode = (data) => action(REQUEST_YOUZAN_MOBILE_CODE, { data })

export const requestProfiles = () => action(REQUEST_PROFILES)

export const requestShoppingCart = () => action(REQUEST_SHOPPING_CART)

export const requestCardOptionsPage = (data) => action(REQUEST_CARD_OPTIONS_PAGE, { data })

export const submitMemberRenew = (data, payType) => action(SUBMIT_MEMBER_RENEW, { data, payType })

export const submitStoreRenew = (payType) => action(SUBMIT_STORE_RENEW, { payType })

export const requestMemberRenew = () => action(REQUEST_MEMBER_RENEW)

export const addEcardData = (data) => action(ADD_ECARD_DATA, { data })

export const requestWechatUser = () => action(REQUEST_WECHAT_USER)

export const instructorApproved = (data) => action(INSTRUCTOR_APPROVED, { data })

export const cdSubmitSiApp = (data) => action(CD_SUBMIT_SI, { data })

export const changeEcardActiveTrue = (data) => action(CHNAGE_ECARDS_ACTIVE_TRUE, { data })

export const changeEcardActiveFalse = (data) => action(CHNAGE_ECARDS_ACTIVE_FALSE, { data })

export const ecards = {
  request: () => action(ECARDS[REQUEST]),
  success: (data) => action(ECARDS[SUCCESS], { data }),
  failure: (error) => action(ECARDS[FAILURE], { error }),
}

export const redeemedFreeCards = {
  request: () => action(REDEEMED_FREE_CARDS[REQUEST]),
  success: (data) => action(REDEEMED_FREE_CARDS[SUCCESS], { data }),
  failure: (error) => action(REDEEMED_FREE_CARDS[FAILURE], { error }),
}

export const cardRequestOptions = {
  request: (id) => action(CARDREQUESTOPTIONS[REQUEST]),
  success: (data) => action(CARDREQUESTOPTIONS[SUCCESS], { data }),
  failure: (error) => action(CARDREQUESTOPTIONS[FAILURE], { error }),
}

export const shareEcards = {
  request: () => action(SHAREECARDS[REQUEST]),
  success: (data) => action(SHAREECARDS[SUCCESS], { data }),
  failure: (error) => action(SHAREECARDS[FAILURE], { error }),
}

export const wechatUser = {
  request: () => action(WECHATUSER[REQUEST]),
  success: (data) => action(WECHATUSER[SUCCESS], { data }),
  failure: (error) => action(WECHATUSER[FAILURE], { error }),
}

export const profile = {
  request: () => action(PROFILE[REQUEST]),
  success: (data) => action(PROFILE[SUCCESS], { data }),
  failure: (error) => action(PROFILE[FAILURE], { error }),
}

export const shoppingCart = {
  request: () => action(SHOPPINGCART[REQUEST]),
  success: (data) => action(SHOPPINGCART[SUCCESS], { data }),
  failure: (error) => action(SHOPPINGCART[FAILURE], { error }),
}

export const hasPigYearCard = {
  request: () => action(HAS_PIG_CARD[REQUEST]),
  success: (data) => action(HAS_PIG_CARD[SUCCESS], { data }),
  failure: (error) => action(HAS_PIG_CARD[FAILURE], { error }),
}

export const submitEcardImgBinding = {
  request: () => action(SUBMIT_ECARD_IMG_BINDING[REQUEST]),
  success: (data) => action(SUBMIT_ECARD_IMG_BINDING[SUCCESS], { data }),
  failure: (error) => action(SUBMIT_ECARD_IMG_BINDING[FAILURE], { error }),
}

export const verifyMobile = {
  request: () => action(VERIFY_MOBILE[REQUEST]),
  success: (data) => action(VERIFY_MOBILE[SUCCESS], { data }),
  failure: (error) => action(VERIFY_MOBILE[FAILURE], { error }),
}

export const submitShoppingCart = {
  request: () => action(SUBMIT_SHOPPING_CART[REQUEST]),
  success: (data) => action(SUBMIT_SHOPPING_CART[SUCCESS], { data }),
  failure: (error) => action(SUBMIT_SHOPPING_CART[FAILURE], { error }),
}

export const memberRenew = {
  request: () => action(MEMBER_RENEW[REQUEST]),
  success: (data) => action(MEMBER_RENEW[SUCCESS], { data }),
  failure: (error) => action(MEMBER_RENEW[FAILURE], { error }),
}

export const storeRenew = {
  request: () => action(STORE_RENEW[REQUEST]),
  success: (data) => action(STORE_RENEW[SUCCESS], { data }),
  failure: (error) => action(STORE_RENEW[FAILURE], { error }),
}

export const memberRenewFuiouOrder = {
  request: () => action(MEMBER_RENEW_FUIOU_ORDER[REQUEST]),
  success: (data) => action(MEMBER_RENEW_FUIOU_ORDER[SUCCESS], { data }),
  failure: (error) => action(MEMBER_RENEW_FUIOU_ORDER[FAILURE], { error }),
}

export const storeRenewFuiouOrder = {
  request: () => action(STORE_RENEW_FUIOU_ORDER[REQUEST]),
  success: (data) => action(STORE_RENEW_FUIOU_ORDER[SUCCESS], { data }),
  failure: (error) => action(STORE_RENEW_FUIOU_ORDER[FAILURE], { error }),
}

export const hideFuiouRenewQr = () => ({ type: HIDE_FUIOU_RENEW_QR })
export const saveProfile = {
  request: () => action(SAVE_PROFILE[REQUEST]),
  success: (data) => action(SAVE_PROFILE[SUCCESS], { data }),
  failure: (error) => action(SAVE_PROFILE[FAILURE], { error }),
}

export const cdSubmitApp = {
  request: (data) => action(CD_SUBMIT_APP[REQUEST], data),
  success: (data) => action(CD_SUBMIT_APP[SUCCESS], { data }),
  failure: (error) => action(CD_SUBMIT_APP[FAILURE], { error }),
}

export const refreshToken = {
  request: (data) => action(REFRESH_TOKEN[REQUEST], data),
  success: (data) => action(REFRESH_TOKEN[SUCCESS], { data }),
  failure: (error) => action(REFRESH_TOKEN[FAILURE], { error }),
}

export const pageLoading = () => action(PAGE_LOADING)
export const pageLoaded = () => action(PAGE_LOADED)
export const loadEcards = () => action(LOAD_ECARDS_PAGE)
export const resetErrorMessage = () => action(RESET_ERROR_MESSAGE)
export const errorDialog = (error) => action(ERRORDIALOG, { error })
export const skipRouter = (router) => action(SKIP_ROUTER, { router })
export const noticeDisplay = (mes) => action(NOTICE_DISPLAY, { mes })
export const noticeHide = () => action(NOTICE_HIDE)
export const showToast = (mes) => action(SHOW_TOAST, { mes })
export const clearToast = () => action(CLEAR_TOAST)
export const clearCardRequestInfo = () => action(CLEAR_CARDREQUEST_INFO)
export const resetApp = () => action(RESET_APP)
export const saveWechatJsConfig = (config) => action(SAVE_WECHAT_JS_CONFIG, { config })
export const skipPath = (path) => action(SKIP_PATH, { path })
